import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private isLoading$: BehaviorSubject<boolean>;
  private isScanning$: BehaviorSubject<boolean>;

  constructor() {
    this.isLoading$ = new BehaviorSubject(false)
    this.isScanning$ = new BehaviorSubject(false);
   }

  getisLoading(): Observable<boolean> {
    return this.isLoading$ as Observable<boolean>
  }

  setisLoading(loading: boolean): void{
    return this.isLoading$.next(loading);
  }

  /**
   * GetIsScanning: This function returns an observable of type `boolean` which indicates
   * whether the scanning is in progress or not.
   *
   * @returns {Observable<boolean>}
   */
  getIsScanning = (): Observable<boolean> => this.isScanning$ as Observable<boolean>

  /**
   * SetIsScanning: This function sets the scanning status by emitting a new value through
   * the `isScanning$` observable.
   */
  setIsScanning = (scanning: boolean) => this.isScanning$.next(scanning);
}
